import React from 'react';

import styles from './styles';

function SuccessStep() {
  const classes = styles();

  return (
    <div className={classes.successMsg}>
      <img width={64} height={63} src='/img/success_icon.svg' alt='Ícone verde de sucesso' />
      <span>Você receberá o arquivo em alguns instantes no e-mail informado.</span>
    </div>
  );
}

export default SuccessStep;
